module.exports = __webpack_public_path__ + "img/growth.ef6aa23b.svg";